/**
 * Query parameters for Agents API when a cloud/region is selected (service deployments).
 *
 * @param {Object} rootState - Vuex root state
 * @returns {Record<string, string>}
 */
export function getAgentsRequestQueryParams(rootState) {
  if (!rootState) return {};
  const params = {};
  if (rootState.selectedRegion) {
    params.region = rootState.selectedRegion;
  }
  if (rootState.selectedCloud != null && rootState.selectedCloud !== '') {
    params.cloud = rootState.selectedCloud;
  }
  return params;
}

/**
 * Payload fields for Agents API POST requests — region/cloud in request body.
 *
 * @param {Object} rootState - Vuex root state
 * @returns {Record<string, string>}
 */
export function getAgentsPayloadParams(rootState) {
  if (!rootState) return {};
  const params = {};
  if (rootState.selectedRegion) {
    params.region = rootState.selectedRegion;
  }
  if (rootState.selectedCloud != null && rootState.selectedCloud !== '') {
    params.cloud = rootState.selectedCloud;
  }
  return params;
}

/**
 * Append region/cloud query params to an absolute Agents URL (preserves existing query).
 *
 * @param {string} url
 * @param {Object} rootState
 * @returns {string}
 */
export function mergeAgentsQueryIntoUrl(url, rootState) {
  const extra = getAgentsRequestQueryParams(rootState);
  if (!Object.keys(extra).length) return url;
  const u = new URL(url);
  Object.entries(extra).forEach(([k, v]) => u.searchParams.set(k, v));
  return u.toString();
}
